const MAP_MIN_ZOOM = 1
const MAP_MAX_ZOOM = 22
const MAP_DEFAULT_ZOOM = 9
const MAP_RADIUS = 20000
const MAX_DISPLAYED_WASTE_TYPES = 4

const MAP_BREAKPOINT_VALUE = 12
const MAP_ADVANCED_ZOOM = 17
const MAP_CITY_ZOOM = 11
const MAP_COUNTRY_ZOOM = 6
export {
  MAX_DISPLAYED_WASTE_TYPES,
  MAP_RADIUS,
  MAP_MIN_ZOOM,
  MAP_MAX_ZOOM,
  MAP_DEFAULT_ZOOM,
  MAP_BREAKPOINT_VALUE,
  MAP_ADVANCED_ZOOM,
  MAP_CITY_ZOOM,
  MAP_COUNTRY_ZOOM
}
